module.exports = __webpack_public_path__ + "assets/bima-f6a3dd5c568f87a046d16b62e35b2d23.svg";